module.exports = __webpack_public_path__ + "img/image73.dfffa9db.jpg";